import { useRef } from "react";
import { DeselectObjectFunction } from "../extensions/objectSelectionExtension";
import { useDispatchBaseEvent, useSubscribeToBaseEvent } from "./useDispatchBaseEvent";

export function useDeselectObjectHandler() {
  const changeLayerFunctionRef = useRef<DeselectObjectFunction>(() => {});

  useSubscribeDeselectObjectEvent(() => {
    changeLayerFunctionRef.current();
  });

  const initDeselectFunction = (fn: DeselectObjectFunction) => {
    changeLayerFunctionRef.current = fn;
  };

  return {
    initDeselectFunction,
  };
}

export const DESELECT_OBJECT_EVENT_NAME = "useDeselectObjectEvent";

type DeselectObjectEvent = {
  type: typeof DESELECT_OBJECT_EVENT_NAME;
  payload: void;
};

export function useDeselectObjectEvent() {
  return useDispatchBaseEvent<DeselectObjectEvent>(DESELECT_OBJECT_EVENT_NAME);
}

export function useSubscribeDeselectObjectEvent(handler: (payload: DeselectObjectEvent["payload"]) => void) {
  useSubscribeToBaseEvent<DeselectObjectEvent>(DESELECT_OBJECT_EVENT_NAME, handler);
}
